import type { ChainPath } from 'modules/supplier/supplier/components/ProductChainPicker';
import { buildSparseTree, expandMediaTargetPrefixes, mediaTargetPathFromProduct } from 'modules/agreement/discountTree';
import { type DiscountTreeNode, type ProviderAgreementDiscountRule } from './types';

export const pathFromProduct = mediaTargetPathFromProduct;

/** Build authored paths only; the editor classifies current target eligibility. */
export function buildTree(rules: readonly ProviderAgreementDiscountRule[]): DiscountTreeNode[] {
  return buildSparseTree(rules) as DiscountTreeNode[];
}

/** Expand complete eligible media chains into selectable prefixes. */
export function targetOptions(paths: readonly ChainPath[]) {
  return expandMediaTargetPrefixes(paths);
}
